import React from 'react';
import { Card, CardContent, Typography, Button, Box, useMediaQuery, Theme } from '@mui/material';

interface Price {
  priceId: string;
  name: string;
  description: string;
  amount: number;
  currency: string;
  interval: string;
}

interface SubscriptionPlanCardProps {
  price: Price;
  selectedPlan: string | null;
  onSelect: (priceId: string) => void;
}

const SubscriptionPlanCard: React.FC<SubscriptionPlanCardProps> = ({ price, selectedPlan, onSelect }) => {
  const SetInterval = (interval: string) => {
    if (interval === '1 month') return 'mo';
    if (interval === '12 months') return 'year';
    if (interval === '36 months') return '3-years';
    return '';
  };

  return (
    <Card onClick={() => onSelect(price.priceId)} variant='outlined' sx={{
        textAlign: 'left',
        minWidth: '250px',
        borderRadius: '24px',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
    }}>
      <CardContent
        sx={{
          flexGrow: 1,
        }}>
        <Box
          sx={{
            borderColor: '#CCCCCC',
          }}>
          <Typography sx={{
              backgroundColor: 'var(--light-pink)',
              color: 'var(--dark-purple)',
              borderRadius: '24px',
              marginBottom: '12px',
              padding: '8px 16px',
              fontFamily: 'DM Sans, sans-serif',
              fontSize: '13px',
              display: 'inline-block',
          }}>{price.name}</Typography>
          <Typography
            sx={{
              color: 'inherit',
            }}>
            <Typography sx={{
                color: 'var(--dark-blue)',
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '26px',
                lineHeight: '150%',
            }}>
              {price?.currency === 'usd' ? '$' : ''}
              {price?.amount / 100}/{SetInterval(price?.interval)}
            </Typography>
          </Typography>
        </Box>

        <Typography sx={{ color: 'inherit' }}>
          <div className='pricing-description' dangerouslySetInnerHTML={{ __html: price.description }} />
        </Typography>
      </CardContent>

      <Box display='flex' alignItems='center' justifyContent='center' sx={{ paddingBottom: '1rem', marginTop: 'auto' }}>
        <Button
          sx={{
            bgcolor: '#0072CE',
            height: '3.18rem',
            width: '12.75rem',
            borderRadius: '12.5rem',
            '&:hover': {
              bgcolor: '#0072CE',
            },
          }}>
          <Typography color='#fff' variant='button'>
            Choose plan
          </Typography>
        </Button>
      </Box>
    </Card>
  );
};

export default SubscriptionPlanCard;
